import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { CityEditForm } from "@/features/city/CityEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function CityEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/city",
            label: "City (Kota/Kab)",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit City (Kota/Kab)</H2>
      <CityEditForm id={id} />
    </>
  );
}
